export const PAYSAGE = 'paysage';
export const PORTRAIT = 'portrait';
